import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getCongeByUserCodeId } from "../../../Services/Pointeuse/CongeApi";
import { getHolidayByCode } from "../../../Services/Pointeuse/HolidayApi";
import { getUsersByCode } from "../../../Services/Pointeuse/UsersApi";
import { getAllVaccinByCode } from "../../../Services/Pointeuse/VaccinApi";
import { filterCongeByYear, filterYearAutorisation } from "../../../Utils/userDetaiUtils";
import CustomSyncLoader from "../../Others/CustomSyncLoader";
import ErrorCustum from "../../Others/ErrorCustum";
import { useTranslation } from 'react-i18next';

function PieApexVaccination() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    getUsersByCode()
      .then((resUser) => {
        getAllVaccinByCode().then((res) => {
          let chartOptions = {
            series: [res.data.length, resUser.data.length],
            options: {
              chart: {
                // width: 300,
                type: "polarArea",
                sparkline: {
                  enabled: true,
                },
              },
               labels: ["Non Vacciné", "Vacciné"],
              fill: {
                opacity: 1,
                colors: ["#F7284A", "#0DCD94"],
              },
              stroke: {
                width: 0,
                colors: undefined,
              },
              yaxis: {
                show: false,
              },
              legend: {
                position: "bottom",
              },
              plotOptions: {
                polarArea: {
                  rings: {
                    strokeWidth: 0,
                  },
                },
              },
              theme: {
                monochrome: {
                  enabled: true,
                  shadeTo: "light",
                  shadeIntensity: 0.6,
                },
              },
            },
          };
          setData(chartOptions);
        });
      })

      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  }, []);
  return (
    <>
      {loading && <CustomSyncLoader></CustomSyncLoader>}
      {!loading && error && <ErrorCustum></ErrorCustum>}
      {!loading && !error && data && (
        <ReactApexChart
          options={data.options}
          series={data.series}
          type="polarArea"
          height={251}
          // width={300}
        />
      )}
    </>
  );
}

export default PieApexVaccination;
